import { createFileRoute } from '@tanstack/react-router'

import { SidebarContent } from '@/containers/payouts'
import { payoutsSearchSchema } from '@/lib/searchSchemas/payouts'
import {
  orgFeesQueryOptions,
  orgInfoQueryOptions,
} from '@/queries/organization'
import { paymentProfileQueryOptions } from '@/queries/profile'
import { selectOrgData } from '@/selectors/organization'

export const Route = createFileRoute('/_authenticated/account/_dashboard/')({
  validateSearch: payoutsSearchSchema,
  beforeLoad: async ({ context: { queryClient, orgStore } }) => {
    const data = queryClient.getQueryData(
      orgInfoQueryOptions(orgStore.getState().orgId).queryKey
    )
    const { orgName } = selectOrgData(data)
    const promises = [
      queryClient.ensureQueryData(paymentProfileQueryOptions),
      queryClient.ensureQueryData(
        orgFeesQueryOptions(orgStore.getState().orgId)
      ),
    ]
    await Promise.all(promises)
    return {
      SidebarComponent: SidebarContent,
      title: 'Payouts',
      subTitle: `View and manage your ${orgName} payouts.`,
    }
  },
})
